// Lógica pura del reproductor de tutoriales: formato de tiempo y capítulos. Los videos y sus capítulos los genera
// `e2e/tutoriales` y se publican con `scripts/publicar-tutoriales.mjs` (ver README, «Videos tutoriales»).

/** `75` → `"1:15"`. Redondea hacia abajo; un valor no válido o negativo es `"0:00"`. */
export function formatoTiempo(segundos) {
  const total = Number.isFinite(segundos) && segundos > 0 ? Math.floor(segundos) : 0;
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * Id del último capítulo que ya empezó en el segundo `t`, o `null` si no hay capítulos o `t` no es válido.
 * @param {Array<{id:string, inicioS:number}>|undefined} capitulos ordenados por `inicioS`
 * @param {number} t
 */
export function capituloActual(capitulos, t) {
  if (!Array.isArray(capitulos) || capitulos.length === 0 || !Number.isFinite(t)) return null;
  let actual = null;
  for (const c of capitulos) {
    if (c.inicioS <= t) actual = c.id;
    else break;
  }
  return actual;
}

/**
 * Deja solo los capítulos bien formados (id, título y tiempo numérico) de la respuesta del JSON, ordenados por
 * tiempo. Cualquier otra forma da `[]`: el tutorial se ve igual, solo que sin lista de capítulos.
 */
export function normalizarCapitulos(datos) {
  const lista = datos && typeof datos === 'object' ? datos.capitulos : null;
  if (!Array.isArray(lista)) return [];
  return lista
    .filter(
      (c) =>
        c &&
        typeof c.id === 'string' &&
        typeof c.titulo === 'string' &&
        c.titulo.trim() !== '' &&
        typeof c.inicioS === 'number' &&
        Number.isFinite(c.inicioS)
    )
    .map((c) => ({ id: c.id, titulo: c.titulo, inicioS: c.inicioS }))
    .sort((a, b) => a.inicioS - b.inicioS);
}
